import React from "react";
import { Check } from "lucide-react";
import { WhatsappButton } from "./WhatsappButton";

export function ProductCard({ product, categoryName }) {
  return (
    <div
      className="group flex flex-col bg-white rounded-2xl border border-line p-6 soft-shadow transition-all duration-300 hover:-translate-y-1.5 hover:soft-shadow-lg"
      data-testid={`product-card-${product.id}`}
    >
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-heading font-bold text-lg text-navy leading-tight">{product.name}</h3>
        {product.badge && (
          <span className="shrink-0 text-[10px] uppercase tracking-wider font-bold bg-brand text-white px-2.5 py-1 rounded-full">
            {product.badge}
          </span>
        )}
      </div>

      {product.price && (
        <div className="mt-3 font-heading font-extrabold text-2xl text-brand-dark">{product.price}</div>
      )}

      {product.description && (
        <p className="mt-3 text-sm text-navy-soft leading-relaxed">{product.description}</p>
      )}

      {product.features && product.features.length > 0 && (
        <ul className="mt-4 space-y-2 flex-1">
          {product.features.map((f, i) => (
            <li key={i} className="flex items-start gap-2 text-sm text-navy">
              <Check className="w-4 h-4 text-brand-dark mt-0.5 shrink-0" />
              <span>{f}</span>
            </li>
          ))}
        </ul>
      )}

      <div className="mt-6">
        <WhatsappButton
          product={product.name}
          category={categoryName}
          template={product.whatsapp_message_template}
          fullWidth
          testId={`whatsapp-btn-${product.id}`}
        />
      </div>
    </div>
  );
}
